import BigNumber from 'bignumber.js'
import { BIG_ZERO } from 'utils/bigNumber'
import { getIfoCreditAddressContract } from 'utils/contractHelpers'

export const fetchPublicIfoData = async (chainId: number) => {
  try {
    const ifoCreditAddressContract = getIfoCreditAddressContract(undefined, chainId)
    const ceiling = await ifoCreditAddressContract.ceiling()
    return {
      ceiling: new BigNumber(ceiling.toString()).toJSON(),
    }
  } catch (error) {
    return {
      ceiling: BIG_ZERO.toJSON(),
    }
  }
}

export const fetchUserIfoCredit = async (account: string, chainId: number) => {
  try {
    const ifoCreditAddressContract = getIfoCreditAddressContract(undefined, chainId)
    const credit = await ifoCreditAddressContract.getUserCredit(account)
    return new BigNumber(credit.toString()).toJSON()
  } catch (error) {
    return BIG_ZERO.toJSON()
  }
}
